import React, { Component } from "react";
import ItemSlider from "./ItemSlider/ItemSlider";

class ItemScroll extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isMounted: false,
        };
    }

    componentDidMount() {
        if (this.props.items) {
            this.setState({
                isMounted: true,
                items: [...this.props.items],
            });
        }
        if (this.props.settings) {
            this.settings = this.props.settings;
        }
    }
    render() {
        const { title, mainTitle, itemType, color, link, linktext, fullwidth, buttonColor, hasBackgroundColor } = this.props;
        return (
            <div id="product-list-block" className={`item-scroll ${fullwidth === "True" ? "item-scroll--full-width" : ""}`} style={{ color: color }}>
                
                {title && mainTitle === 'True' && (
                    <h1 className="item-scroll__title">{title}</h1>
                )}
                {title && mainTitle === 'False' && (
                    <h2 className="item-scroll__title">{title}</h2>
                )}
                {this.state.isMounted && (
                    <ItemSlider items={this.state.items} itemType={itemType} color={color} buttonColor={buttonColor} cssBlock="item-scroll" title={title} />
                )}
                {link && linktext &&
                    <a href={link} className="item-scroll__link" style={{ color: color }}>{linktext}</a>
                }
            </div>
        );
    }
}
export default ItemScroll;
